import { render } from "./your-profile-component.vue?vue&type=template&id=cc613d3c"
import script from "./your-profile-component.vue?vue&type=script&lang=js"
export * from "./your-profile-component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__